class ToastManager {
    private container: HTMLDivElement | null = null;

    private createContainer() {
        if (this.container && document.getElementById('custom-toast-container')) return;

        this.container = document.createElement('div');
        this.container.id = 'custom-toast-container';
        Object.assign(this.container.style, {
            position: 'fixed',
            top: '24px',
            left: '50%',
            transform: 'translateX(-50%)',
            zIndex: '100000',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '10px',
            pointerEvents: 'none'
        });

        const styleId = 'custom-toast-styles';
        if (!document.getElementById(styleId)) {
            const style = document.createElement('style');
            style.id = styleId;
            style.innerHTML = `
                @media (max-width: 480px) {
                    #custom-toast-container {
                        left: 16px !important;
                        right: 16px !important;
                        transform: translateX(0) !important;
                        top: 16px !important;
                        align-items: center !important;
                    }
                    .custom-toast {
                        width: 100% !important;
                        max-width: 100% !important;
                    }
                }
                @keyframes toastSlideIn {
                    from { transform: translateY(-30px); opacity: 0; }
                    to { transform: translateY(0); opacity: 1; }
                }
                @keyframes toastSlideOut {
                    from { transform: translateY(0); opacity: 1; }
                    to { transform: translateY(-30px); opacity: 0; }
                }
            `;
            document.head.appendChild(style);
        }
        document.body.appendChild(this.container);
    }

    show(message: string, type: 'success' | 'error' | 'warning' | 'info' = 'success', duration = 3500) {
        this.createContainer();
        const parent = this.container || document.getElementById('custom-toast-container');
        if (!parent) return;

        // Prevent duplicate toasts
        const existingToasts = parent.getElementsByClassName('custom-toast');
        for (let i = 0; i < existingToasts.length; i++) {
            const tEl = existingToasts[i] as HTMLDivElement;
            const textSpan = tEl.querySelector('span');
            if (textSpan && textSpan.innerText === message) {
                return; // Return early if this message is already showing
            }
        }

        const toast = document.createElement('div');
        toast.className = 'custom-toast';
        
        const bgColor = type === 'success' ? '#e6f9f9' : type === 'error' ? '#fff0f3' : type === 'warning' ? '#fff9e6' : '#f5f6f8';
        const borderColor = type === 'success' ? '#43c8ca' : type === 'error' ? '#f35a82' : type === 'warning' ? '#f59e0b' : '#94969f';
        const textColor = type === 'success' ? '#149a8f' : type === 'error' ? '#e02f5a' : type === 'warning' ? '#b45309' : '#282c3f';

        Object.assign(toast.style, {
            padding: '14px 20px',
            backgroundColor: bgColor,
            color: textColor,
            borderLeft: `4px solid ${borderColor}`,
            borderTop: `1px solid ${borderColor}22`,
            borderRight: `1px solid ${borderColor}22`,
            borderBottom: `1px solid ${borderColor}22`,
            boxShadow: '0 4px 16px rgba(0,0,0,0.08)',
            fontFamily: 'Inter, system-ui, sans-serif',
            fontSize: '12px',
            fontWeight: '700',
            textTransform: 'uppercase',
            letterSpacing: '0.5px',
            pointerEvents: 'auto',
            animation: 'toastSlideIn 0.3s cubic-bezier(0.16, 1, 0.3, 1) forwards',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: '12px',
            width: '320px',
            borderRadius: '0px'
        });

        const textSpan = document.createElement('span');
        textSpan.innerText = message;
        textSpan.style.textAlign = 'left';
        textSpan.style.flex = '1';
        toast.appendChild(textSpan);

        const closeBtn = document.createElement('button');
        closeBtn.innerHTML = '&times;';
        Object.assign(closeBtn.style, {
            background: 'none',
            border: 'none',
            color: textColor,
            fontSize: '18px',
            cursor: 'pointer',
            padding: '0',
            lineHeight: '1',
            opacity: '0.7',
            transition: 'opacity 0.2s'
        });
        closeBtn.onmouseover = () => { closeBtn.style.opacity = '1'; };
        closeBtn.onmouseout = () => { closeBtn.style.opacity = '0.7'; };
        closeBtn.onclick = () => this.removeToast(toast);
        toast.appendChild(closeBtn);

        parent.appendChild(toast);

        setTimeout(() => {
            this.removeToast(toast);
        }, duration);
    }

    success(message: string, duration?: number) {
        this.show(message, 'success', duration);
    }

    error(message: string, duration?: number) {
        this.show(message, 'error', duration);
    }

    warning(message: string, duration?: number) {
        this.show(message, 'warning', duration);
    }

    info(message: string, duration?: number) {
        this.show(message, 'info', duration);
    }

    private removeToast(toast: HTMLDivElement) {
        toast.style.animation = 'toastSlideOut 0.3s cubic-bezier(0.16, 1, 0.3, 1) forwards';
        toast.addEventListener('animationend', () => {
            if (toast.parentNode) {
                toast.parentNode.removeChild(toast);
            }
        });
    }
}

export const toast = new ToastManager();
export default toast;
